export default "__VITE_ASSET__CbV1Eybq__"